<div class="comment">
  <div class="container">
    <div class="message-block">
      <div class="avatar" [class.response]="!!reply_to">
        <on-ui-cover [cover]="avatar"></on-ui-cover>
      </div>
      <div class="center">
        <div class="name-wrap">
          <a *ngIf="comment.author" [routerLink]="accountRoute"
             class="name">{{ fullName }}</a>
          <p class="time">{{ publishedAtDate | dfnsFormatDistanceToNowStrictPure: {addSuffix: true} }}</p>
        </div>
        <p class="text">{{ comment.text | striptags | nl2br }}</p>
        <span *ngIf="replyEnabled" class="answer-btn" (click)="toggleCommentForm()">
          {{ 'comments.answer' | translate }}
        </span>
      </div>
    </div>

    <div class="tools-block">
      <!-- мой комментарий: удалить -->
      <ng-template [ngIf]="me.id === comment.author_id">
        <div class="delete-btn" (click)="removeComment()" [title]="'comments.delete' | translate">
          <app-icon class="icon" icon="close"></app-icon>
        </div>
      </ng-template>

      <!-- аноним отправляется в авторизацию -->
      <ng-template [ngIf]="likeEnabled && isGuest">
        <div class="like-btn" (click)="authorize()">
          <app-icon class="like-icon" icon="like"
                    [class.like-icon--like]="likesCount > 0"
                    [class.like-icon--is-liked]="likesCount > 0 && isLiked">
          </app-icon>
          <span class="like-number" [class.like-number--like]="likesCount > 0 && isLiked">{{ likesCount === 0 ? '' : likesCount }}</span>
        </div>
      </ng-template>

      <!-- чужой комментарий: пожаловаться и лайкнуть -->
      <ng-template [ngIf]="!isGuest && me.id !== comment.author_id">
        <div class="complaint-btn" [title]="'comments.complain' | translate" (click)="openComplainForm()">
          <app-icon class="icon" icon="close"></app-icon>
        </div>

        <!-- переключить лайк -->
        <div *ngIf="likeEnabled" class="like-btn" (click)="toggleLike()">
          <app-icon class="like-icon" icon="like"
                    [class.like-icon--like]="likesCount > 0"
                    [class.like-icon--is-liked]="likesCount > 0 && isLiked">
          </app-icon>
          <span class="like-number" [class.like-number--like]="likesCount > 0 && isLiked">{{ likesCount === 0 ? '' : likesCount }}</span>
        </div>
      </ng-template>
    </div>
  </div>

  <app-comment-form *ngIf="commentForm" (commented)="onCommented()"></app-comment-form>

  <div *ngIf="replyEnabled && !reply_to" class="replies">
    <div *ngFor="let response of responses; trackBy: trackByFn" class="reply-item">
      <app-comment [reply_to]="comment" [comment]="response" [content]="content"></app-comment>
    </div>
    <span class="replies--more">{{ 'comments.next-responses' | translate }}</span>
  </div>
</div>

<app-modal *ngIf="complainForm && deviceService.isDesktop()"
           (closed)="closeComplainForm()"
           canClose="true"
           middle="true">
  <app-modal-body>
    <app-complaint-form [type]="'content'" (cancel)="closeComplainForm()"></app-complaint-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="complainForm && !deviceService.isDesktop()"
                  [titleVisible]="false"
                  (closed)="closeComplainForm()">
  <app-mobile-modal-body>
    <app-complaint-form [type]="'content'" (cancel)="closeComplainForm()"></app-complaint-form>
  </app-mobile-modal-body>
</app-mobile-modal>
